
  <a class="card a_tile" [routerLink]="routerLink">
    <div class="card-body"><i class="{{iconCSS}} d-block text-center" aria-hidden="true" style="font-size:30px;"></i><span class="d-block text-center">{{linkText}}</span></div>
  </a>

